import { error } from 'services/graphql/fragments/Fragments';
import { incentiveStatusFields } from 'services/graphql/fragments/IncentiveFragments';
import { gql } from 'urql';

const IncentiveStatus = gql`
  query IncentiveStatus($input: IncentiveStatusInput!) {
    incentiveStatus(input: $input) {
      __typename
      ... on IncentiveStatusSuccess {
        status {
          ...incentiveStatusFields
        }
      }
      ... on IncentiveStatusError {
        ...error
      }
    }
  }
  ${incentiveStatusFields}
  ${error}
`;

export default IncentiveStatus;
